exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".editor{overflow:hidden;background-color:#e7e7e7}.editor .ProseMirror{padding:16px}.editor.is-comment{border-radius:50px}.editor.is-comment .ProseMirror{padding-bottom:10px;padding-top:10px;background-color:#e7e7e7}.editor.is-comment .ProseMirror:focus{outline:none!important}.editor.is-comment .ProseMirror p{margin-bottom:0!important}.mention{background:rgba(24,119,242,.2);font-size:.8rem;font-weight:700;border-radius:5px;padding:.2rem .5rem;white-space:nowrap}.mention,.mention-suggestion{color:rgba(0,0,0,.6)}p.is-empty:first-child:before{content:attr(data-empty-text);float:left;color:#888;pointer-events:none;height:0}", ""]);

// exports
